import React from 'react'
import SignIn from './SignIn.js'

function SignUp() {
  return <SignIn screenHint="signup" />
}

export default SignUp
